import Vue from 'vue';
import App from './App.vue';
import Buefy from 'buefy';
import VeeValidate from 'vee-validate';
import { Validator } from 'vee-validate';
import router from './router';
import store from './store';
import Axios from 'axios';
import PhoneNumber from 'awesome-phonenumber';
import vSelect from 'vue-select';
import xmljs from 'xml-js';
import Cleave from 'vue-cleave-component';
import CleavePhone from 'cleave.js/dist/addons/cleave-phone.us';
import moment from 'moment';
import jQuery from 'jquery';
import MaskedInput from 'vue-text-mask';
import './util.js';
import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations';
import { Integrations } from '@sentry/tracing';
import vueEasyMq from 'vue-easy-mq';
// import 'buefy/src/scss/buefy.scss';

/* import the fontawesome core */
import { library as faLibrary } from '@fortawesome/fontawesome-svg-core';

/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

/* import specific icons */
import {
  faBars as falBars,
  faCalendar as falCalendar,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faUser as falUser,
  faTimes as falTimes
} from '@fortawesome/pro-light-svg-icons';
import {
  faBars,
  faCalendar,
  faEnvelope,
  faList,
  faMinus,
  faPlus,
  faTimes,
  faUser
} from '@fortawesome/pro-regular-svg-icons';
import {
  faBars as fasBars,
  faCalendar as fasCalendar,
  faCheck,
  faFileInvoice,
  faIdCard,
  faPhoneVolume,
  faSave,
  faShoppingCart,
  faSyncAlt,
  faUser as fasUser,
  faTimes as fasTimes
} from '@fortawesome/pro-solid-svg-icons';

faLibrary.add(
  faBars,
  falBars,
  fasBars,
  faCalendar,
  falCalendar,
  fasCalendar,
  faCheck,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faEnvelope,
  faFileInvoice,
  faIdCard,
  faList,
  faMinus,
  faPlus,
  faPhoneVolume,
  faSave,
  faShoppingCart,
  faSyncAlt,
  faTimes,
  falTimes,
  fasTimes,
  faUser,
  falUser,
  fasUser
);
moment.defaultFormat = 'YYYY-MM-DD[T]12:00:00[Z]';
window.moment = moment;

Vue.prototype.$jQuery = jQuery;
Vue.prototype.$http = Axios;
Vue.prototype.$phoneNumber = '800-400-4128';
Vue.prototype.$emailAddress = 'customercare@porscheautoinsurance.com';

Vue.config.productionTip = false;
Vue.config.devtools = true;

Vue.component('v-select', vSelect);
Vue.component('vue-fontawesome', FontAwesomeIcon);

const dictionary = {
  attributes: {
    agencyName: 'Agency Name',
    car: 'Car',
    confirmNewPassword: 'Confirm New Password',
    currentPassword: 'Verify Current Password',
    delivery: 'Delivery',
    email: 'Email',
    emailAddress: 'Email Address',
    firstName: 'First Name',
    lastName: 'Last Name',
    newPassword: 'New Password',
    newPassword2: 'Confirm New Password',
    password: 'Password',
    password2: 'Password',
    phoneNumber: 'Phone Number',
    policyNumber: 'Policy Number',
    verifyPassword: 'Verify Password',
    zipCode: 'ZIP Code'
  },
  custom: {
    car: {
      required: 'At least one Car must be selected.'
    },
    delivery: {
      required: 'At least one Delivery method must be selected.'
    },
    email: {
      required: 'Please enter a valid email address.'
    }
  }
};

let phoneNumber = {
  validate(value) {
    return new Promise(resolve => {
      let phone = new PhoneNumber(value, 'US');
      resolve({
        valid: phone.isValid()
      });
    });
  }
};

Vue.use(Buefy, {
  defaultIconPack: 'fa',
  defaultIconComponent: 'vue-fontawesome',
  defaultDateFormatter: date => moment(date).format('MM/DD/YYYY')
});

Vue.use(VeeValidate, {
  events: 'blur'
});

Vue.use(xmljs);

Vue.use(Cleave);
Vue.use(CleavePhone);

Vue.use(vueEasyMq, {
  debug: false,
  breakpoints: [
    { xs: 449 },
    { sm: 744 },
    { md: 999 },
    { lg: 1299 },
    { lg: 0 /* no max-width */ }
  ]
});

Vue.component('masked-input', MaskedInput);

Validator.localize('en', dictionary);
Validator.extend('phoneNumber', phoneNumber);

VeeValidate.Validator.extend('verify_password', {
  validate: value => {
    var strongRegex = new RegExp(
      '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{10,})'
    );

    return strongRegex.test(value);
  }
});

VeeValidate.Validator.extend('validate18YrsOld', {
  validate: value => {
    var strongRegex = new RegExp(
      '^(0[1-9]|1[0-2])/(0[1-9]|[1-2][0-9]|3[0-1])/[0-9]{4}$'
    );
    if (strongRegex.test(value)) {
      const dateDifferences = moment().diff(new Date(value), 'years');
      if (dateDifferences >= 18 && dateDifferences <= 120) {
        return true;
      } else {
        return false;
      }
    }
    return strongRegex.test(value);
  }
});

VeeValidate.Validator.extend('isLeapYear', {
  validate: value => {
    var strongRegex = new RegExp(
      '^(0[1-9]|1[0-2])/(0[1-9]|[1-2][0-9]|3[0-1])/[0-9]{4}$'
    );
    if (strongRegex.test(value)) {
      if (moment(value, 'MM/DD/YYYY', true).isValid()) {
        return true;
      } else {
        return false;
      }
    }
  }
});

VeeValidate.Validator.extend('validate16YrsOld', {
  validate: value => {
    var strongRegex = new RegExp(
      '^(0[1-9]|1[0-2])/(0[1-9]|[1-2][0-9]|3[0-1])/[0-9]{4}$'
    );
    if (strongRegex.test(value)) {
      const dateDifferences = moment().diff(new Date(value), 'years');
      if (dateDifferences >= 16 && dateDifferences <= 120) {
        return true;
      } else {
        return false;
      }
    }
    return strongRegex.test(value);
  }
});

VeeValidate.Validator.extend('onlyFutureDate', {
  validate: value => {
    var strongRegex = new RegExp(
      '^(0[1-9]|1[0-2])/(0[1-9]|[1-2][0-9]|3[0-1])/[0-9]{4}$'
    );
    if (strongRegex.test(value)) {
      if (moment().diff(new Date(value), 'd') <= 0) {
        return true;
      } else {
        return false;
      }
    }
    return strongRegex.test(value);
  }
});

VeeValidate.Validator.extend('pastMonth', {
  validate: value => {
    var strongRegex = new RegExp(
      '^(0[1-9]|1[0-2])/(0[1-9]|[1-2][0-9]|3[0-1])/[0-9]{4}$'
    );
    if (strongRegex.test(value)) {
      const dateDifferences = moment()
        .startOf('day')
        .diff(new Date(value), 'd');
      if (dateDifferences >= 0 && dateDifferences <= 30) {
        return true;
      } else {
        return false;
      }
    }
    return strongRegex.test(value);
  }
});

VeeValidate.Validator.extend('effectiveDateValidator', {
  validate: value => {
    var strongRegex = new RegExp(
      '^(0[1-9]|1[0-2])/(0[1-9]|[1-2][0-9]|3[0-1])/[0-9]{4}$'
    );
    let dateDiff = moment().diff(new Date(value), 'd');
    if (strongRegex.test(value)) {
      if (dateDiff <= 0 && dateDiff > -45) {
        return true;
      } else {
        return false;
      }
    }
    return strongRegex.test(value);
  }
});

VeeValidate.Validator.extend('insuredValueValidator', {
  validate: value => {
    var val = Number(value.toString().replace(/[^0-9]/g, ''));
    if (val >= 1000 && val <= 300000) {
      return true;
    } else {
      return false;
    }
  }
});

Sentry.init({
  dsn:
    'https://4f1cc976cf164f4cbf735bff734e5683@o345548.ingest.sentry.io/5409836',
  environment: process.env.VUE_APP_ENV,
  release: `Porsche-Auto-Web-${process.env.VUE_APP_VERSION}`,
  integrations: [
    new VueIntegration({
      Vue,
      attachProps: true,
      logErrors: true,
      tracing: true
    }),
    new Integrations.BrowserTracing()
  ],
  tracesSampleRate: 1
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
